import React from 'react';
import { Navigate } from 'react-router-dom';
import useAuthContext from 'stores/auth-context';
import { hasPermission } from 'utils/permission';

interface RequirePermissionProps {
  permission: string;
  children: React.ReactNode;
}

const RequirePermission: React.FC<RequirePermissionProps> = ({ permission, children }) => {
  const { profile } = useAuthContext();
  const permissions = profile?.data?.permissionKeys || [];

  const isPermission = React.useMemo(() => {
    return hasPermission(permission, permissions);
  }, [permission, permissions]);

  if (!isPermission) {
    return <Navigate to='/403' replace />;
  }

  return <>{children}</>;
};

export default RequirePermission;
